export class IndexSelector{
    history:number[] = []
    indexCount:number
    maxHistory:number
    constructor(indexCount:number, maxSelectionHistory:number = 1){
        this.maxHistory = maxSelectionHistory
        this.history = [Math.floor(Math.random() * indexCount)]
        this.indexCount = indexCount
    }
    getOptions = () => {
        const options:number[] = []
        for(let i = 0; i < this.indexCount; i++){ 
            if(!this.history.includes(i)){ options.push(i)}
        }
        return options
    }
    addToHistory = (position:number) => {
        if(this.history.includes(position)){return}
        this.history.push(position)
        const surplus:number = this.history.length - this.maxHistory
        if(surplus > 0){
            this.history.splice(0, surplus)
        }
    }
    getRandomPosition(initial:boolean = false){
        if(initial){
            return this.history[this.history.length - 1]
        }
        let positions:number[] = this.getOptions()
        const randomIndex:number = Math.floor(Math.random() * positions.length)
        const position:number = positions[randomIndex]
        this.addToHistory(position)
        return position
    }
}